import { useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, Link } from "react-router-dom";
import {
  fetchOrderById,
  fetchClientOrders,
} from "../../../../../redux/actions/clientActions";
import moment from "moment";
import { Row, Col, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReply, faUsers } from "@fortawesome/free-solid-svg-icons";
import { NavContext } from "../../../../NavContext";
import OrderNavigation from "../order/orderNavigation";

const TicketsPage = () => {
  const dispatch = useDispatch();
  const { clientId, orderId } = useParams();
  const order = useSelector((state) => state.clientReducer.order);
  const { activeNav, setActiveNav } = useContext(NavContext);
  useEffect(() => {
    setActiveNav("clients");
  }, [setActiveNav]);

  const currentUser = useSelector((state) => state.authReducer.user.user);
  const client = useSelector((state) => state.clientReducer.client);

  useEffect(() => {
    if (clientId) {
      dispatch(fetchClientOrders(clientId));
    }
  }, [dispatch, clientId]);

  const MANAGER = currentUser.role === "manager";
  const teamPrefixes = ["Team1", "Team2", "Team3", "Team4", "Team5"];
  const checkAuthorization = (team) => {
    return (
      currentUser.departement === team &&
      (MANAGER || currentUser._id === order?.[team.toLowerCase() + "Responsible"]?._id)
    );
  };

  const AUTHORIZED = teamPrefixes.some((team) => checkAuthorization(team));

  useEffect(() => {
    document.title =
      "ProdOTop -  demandes de " +
      order?.product?.name +
      " du client " +
      client?.companyName;
  }, [client, order]);

  useEffect(() => {
    if (clientId && orderId) {
      dispatch(fetchOrderById(clientId, orderId));
    }
  }, [dispatch, clientId, orderId]);

  return (
    <>
      <>
        <div className="pb-4">
          <nav aria-label="breadcrumb" className="breadcrumb">
            <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-0 px-0 me-sm-6 me-5">
              <li className="breadcrumb-item text-sm"></li>
              <li className="breadcrumb-item text-sm text-dark" aria-current="page">
                <Link to="/clients">clients</Link>
              </li>
              <li className="breadcrumb-item text-sm text-dark " aria-current="page">
                <Link to={`/clients/${client?._id}/orders`}>{client?.companyName}</Link>
              </li>
              {order && (
                <li
                  className="breadcrumb-item text-sm text-dark flex p-0"
                  aria-current="page"
                >
                  <Dropdown className="dropdown-orders">
                    <Dropdown.Toggle id="dropdown-basic">
                      {order.product?.name}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {client?.orders?.map((cl_order) => (
                        <Dropdown.Item
                          as={Link}
                          to={`/clients/${clientId}/orders/${cl_order._id}/tickets`}
                          key={cl_order._id}
                        >
                          {cl_order.product?.name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              )}
              <li
                className="breadcrumb-item text-sm text-dark active"
                aria-current="page"
              >
                Liste des demandes
              </li>
            </ol>
          </nav>
        </div>
        <div className="order-container">
          {order && (
            <OrderNavigation order={order} client={client} currentTab="tickets" />
          )}
          <Row className="row">
            <div className="col-12">
              <div className="card medium-card mb-4 pb-2 purple-border">
                <div className="card-header">
                  <Row className="xmb-5">
                    <Col md={8}>
                      <h6>
                        <span className="product-title px-3 text-white">
                          Liste des demandes
                        </span>
                      </h6>
                    </Col>
                    <Col className="text-end" md={4}>
                      {AUTHORIZED && (
                        <Link
                          to={`/clients/${clientId}/orders/${orderId}/tickets/new`}
                          className="btn bg-gradient-dark mb-0"
                        >
                          Ajouter une demande
                        </Link>
                      )}
                    </Col>
                  </Row>
                </div>
                <div className="card-body px-0 pt-0 pb-2">
                  <div className="table-responsive p-0">
                    <table className="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Sujet
                          </th>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Statut
                          </th>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Date de création
                          </th>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">
                            action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {order &&
                          order.tickets.map((ticket) => (
                            <tr key={ticket._id}>
                              <td className="align-middle text-sm px-4">
                                <div>
                                  {ticket.shared && (
                                    <FontAwesomeIcon
                                      icon={faUsers}
                                      className="pe-2 purple-color"
                                    />
                                  )}
                                  {ticket.subject}
                                </div>
                              </td>
                              <td className="align-middle text-sm px-4">
                                <div>
                                  {ticket.closed ? (
                                    <span className="badge badge-sm bg-gradient-danger">
                                      Clôturé
                                    </span>
                                  ) : (
                                    <span className="badge badge-sm bg-gradient-success">
                                      Ouvert
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="align-middle text-sm px-4">
                                <div>{moment(ticket.createdAt).format("YYYY-MM-DD")}</div>
                              </td>
                              <td className="align-middle px-2 text-sm text-end">
                                <Link
                                  to={`/clients/${clientId}/orders/${order._id}/tickets/${ticket._id}`}
                                  className="btn btn-link text-warning text-gradient px-3 mb-0"
                                >
                                  <FontAwesomeIcon icon={faReply} className="px-2" />
                                  Répondre
                                </Link>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <Row className="mb-3">
              <Col>
                <Link to={`/clients/${clientId}/orders`} className="link-action back">
                  Retour
                </Link>
              </Col>
            </Row>
          </Row>
        </div>
      </>
    </>
  );
};

export default TicketsPage;
